// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 767.98px){form .tw-card-row{flex-direction:column}}form .remuneration-row input{width:auto;margin:auto;text-align:center}@media (max-width: 767.98px){form .search-localisation-row-first{padding-top:10px !important}}\n", ""]);
// Exports
module.exports = exports;
